<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="退出登录" title="主页" @click-left="onClickLeft">
    </van-nav-bar>
    <van-grid :column-num="3" icon-size="50px" style="font-weight: bold">
      <van-grid-item v-for="(menu,index) in menus" :key="index" :text="menu.text" @click="clickMenu(menu)">
        <template #icon="props">
          <van-icon :name="menu.icon" class-prefix="icon" color="#4592d8" size="50px" />
        </template>
      </van-grid-item>
    </van-grid>
  </div>
</template>
<script>
  import { getMenus, getUser } from '@/pdaView/utils'
  import { Dialog, Toast } from 'vant'
  import { clearVue } from '@/utils/util'

  export default {
    name: 'PdaIndex',
    components: {
      [Dialog.Component.name]: Dialog.Component
    },
    data() {
      return {
        menus: [],
        username: ''
      }
    },
    created() {
      const user = getUser()
      this.username = user.name
      const userMenus = user.menus.filter(item => item.leaf === true && item.available === true).sort((a, b) => a.ordinal - b.ordinal)
      const pdaMenus = getMenus()
      _.forEach(userMenus, row => {
        let matchValue = pdaMenus.find(item => item.name === row.no)
        if (matchValue !== undefined) {
          const newData = {}
          Object.assign(newData, row)
          newData.icon = matchValue.icon
          newData.iconId = matchValue.ordinal
          newData.target = matchValue.target
          newData.text = row.name
          this.menus.push(newData)
        }
      })
    },
    methods: {
      onClickLeft() {
        Dialog.confirm({
          title: '退出',
          message: '确定退出?'
        }).then(() => {
          localStorage.removeItem('warehouseId')
          localStorage.removeItem('userId')
          localStorage.removeItem('user')
          localStorage.removeItem('type')
          localStorage.removeItem('ip')
          clearVue()
          this.$router.push({ name: 'PdaLogin' }, () => {
            Toast('退出成功')
          })
        })
      },
      clickMenu(menu) {
        this.$router.push({ name: menu.no })
      }
    }
  }
</script>